import React from 'react';

import { Badge } from '@thefarmersfront/kitchen';

import { CustomCellRendererProps } from 'ag-grid-react';

import styles from './ManagerNameCellRenderer.module.scss';

const ManagerNameCellRenderer = (param: CustomCellRendererProps) => {
  const isMaster = param.node.rowIndex === 0;
  return (
    <div className={styles['manager-name-cell-wrapper']}>
      <span>{param.value}</span>
      {isMaster && (
        <Badge size="small" variant="stroke">
          대표
        </Badge>
      )}
    </div>
  );
};

export default ManagerNameCellRenderer;
